import { getBooking } from '../api/getBooking'
import { formatMoney } from './formatMoney'
import {
    updateBookingAnalyticsExtras,
    updateBookingAnalyticsState,
} from '../../analytics/holidayParkDataLayer'

function getBookingSummary() {
    return document.querySelector('#booking-summary')
}

function applySummaryBookingDetails(booking = {}) {
    const bookingSummary = getBookingSummary()
    if (!bookingSummary) {
        return
    }

    const values = {
        arrival_date_display: booking.arrival_date_display ?? '',
        departure_date_display: booking.departure_date_display ?? '',
    }

    Object.entries(values).forEach(([key, value]) => {
        const element = bookingSummary.querySelector(`[data-booking-summary-value="${key}"]`)
        if (element && value !== '') {
            element.textContent = value
        }
    })

    const inputMappings = {
        no_of_nights: booking.no_of_nights,
        no_of_adults: booking.no_of_adults,
        no_of_children: booking.no_of_children,
        no_of_pets: booking.no_of_pets,
    }

    Object.entries(inputMappings).forEach(([key, value]) => {
        const input = bookingSummary.querySelector(`[data-stay-editor-input="${key}"]`)
        if (input && value !== undefined && value !== null) {
            input.value = String(value)
        }
    })

    const changeDateLink = bookingSummary.querySelector('[data-booking-summary-change-date]')
    if (changeDateLink && booking.change_date_url) {
        const accommodationUrl = new URL(changeDateLink.href, window.location.origin)
        const updatedBookingUrl = new URL(booking.change_date_url, window.location.origin)

        accommodationUrl.search = updatedBookingUrl.search
        changeDateLink.href = accommodationUrl.toString()
    }
}

function applySummaryPrice(booking = {}, deposit = false) {
    const bookingSummary = getBookingSummary()

    updateBookingAnalyticsState(booking)

    if (!bookingSummary) {
        return ''
    }

    const bookingSummaryPriceElement = bookingSummary.querySelector('#total-price')
    const payInFullElement = document.querySelector('.payment-option.pay-in-full')
    const depositElement = document.querySelector('.payment-option.deposit')
    const depositAmount = booking.deposit_amount ? formatMoney(booking.deposit_amount) : ''
    const fullAmount = booking.checkout_total_price
        ? formatMoney(booking.checkout_total_price)
        : (booking.total_price ? formatMoney(booking.total_price) : '')
    const selectedDeposit = deposit || document.querySelector('#paying_deposit')?.value === 'true'

    if (payInFullElement && fullAmount) {
        payInFullElement.querySelector('#full-price').textContent = fullAmount
    }

    if (depositElement && depositAmount) {
        depositElement.querySelector('#deposit-price').textContent = depositAmount
    }

    document.dispatchEvent(new CustomEvent('holiday-park-booking:updated', {
        detail: {
            booking,
        },
    }))

    if (!bookingSummaryPriceElement) {
        return selectedDeposit ? depositAmount : fullAmount
    }

    bookingSummaryPriceElement.textContent = selectedDeposit && depositAmount ? depositAmount : fullAmount

    return bookingSummaryPriceElement.textContent
}

function applySummaryExtras(extras = []) {
    const bookingSummary = getBookingSummary()

    updateBookingAnalyticsExtras(extras)

    if (!bookingSummary) {
        return
    }

    const extrasSummary = bookingSummary.querySelector('#extras-summary')
    const extrasSummaryContainer = bookingSummary.querySelector('#extras-summary-container')

    if (!extrasSummary || !extrasSummaryContainer) {
        return
    }

    extrasSummary.innerHTML = ''
    let hasSelectedExtras = false

    extras.forEach((extra) => {
        if (Number(extra.quantity ?? 0) <= 0) {
            return
        }

        hasSelectedExtras = true
        const template = bookingSummary.querySelector('.extras-summary-template')?.cloneNode(true)

        if (!template) {
            return
        }

        template.querySelector('.price').textContent = formatMoney(extra.price)
        template.querySelector('.description').textContent = extra.description
        template.querySelector('.pricing-type').textContent = extra.pricing_type
        template.querySelector('.quantity').textContent = `${extra.quantity} x`

        extrasSummary.appendChild(template)
    })

    extrasSummaryContainer.classList.toggle('hidden', !hasSelectedExtras)
}

async function updatePrice(bookingNumber, deposit = false) {
    const booking = await getBooking(bookingNumber)

    if (!booking) {
        return ''
    }

    applySummaryBookingDetails(booking.booking ?? {})

    return applySummaryPrice(booking.booking ?? {}, deposit)
}

async function updateExtras(bookingNumber) {
    const booking = await getBooking(bookingNumber)

    if (!booking) {
        return
    }

    applySummaryExtras(booking.extras ?? [])
}

export {
    applySummaryBookingDetails,
    applySummaryExtras,
    applySummaryPrice,
    updatePrice,
    updateExtras,
}
